export default __webpack_public_path__ + "static/media/bikerace.bd2a26d5.jpg";